<template>
  <div v-for="(item, index) in senderAnalysis" :key="index">
    <div class="tw-mb-4">
      <cl-badge>
        <span class="tw-text-base tw-font-normal">{{ item.status }}</span>
      </cl-badge>
    </div>
    <div class="tw-mb-4">
      <cl-p>{{ item.message }}</cl-p>
    </div>
  </div>
</template>
<script setup lang="ts">
import { IncidentDetailsAnalysis } from "@/modules/PhishTitan/types/IncidentSummary";

defineProps<{ senderAnalysis: IncidentDetailsAnalysis[] }>();
</script>
